export default __webpack_public_path__ + "static/media/infraIcon.7cee7a82.png";